import { render, staticRenderFns } from "./circle.component.vue?vue&type=template&id=19c10f60&scoped=true&"
import script from "./circle.component.vue?vue&type=script&lang=ts&"
export * from "./circle.component.vue?vue&type=script&lang=ts&"
import style0 from "./circle.component.vue?vue&type=style&index=0&id=19c10f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c10f60",
  null
  
)

export default component.exports